import { hapticFeedback } from "@telegram-apps/sdk-react"

type ImpactStyle = "light" | "medium" | "heavy" | "rigid" | "soft"

export const triggerHapticImpact = (style: ImpactStyle = "medium"): void => {
	hapticFeedback.impactOccurred.ifAvailable(style)
}
